import React from 'react';
import { Panel, Label } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { mapStatusToLabel, paymentDetailsLink as detailsLink } from '../paymentHistory/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake } from '@fortawesome/free-regular-svg-icons';
import { faExchange, faTriangleExclamation, faLink } from '@fortawesome/free-solid-svg-icons';

const renderPaymentMethodCell = (paymentMethod) => {
	return paymentMethod ? paymentMethod.name : '';
};

const renderTotalCell = (remainingTotal, row) => {
	return ui.formatAmount(remainingTotal) + (row.refundedTotal ? ` (${ui.formatAmount(row.refundedTotal)
		})` : '');
};

const renderQuantityCell = (remainingQuantity, row) => {
	return remainingQuantity + (row.refundedQuantity ? ` (${row.refundedQuantity})` : '');
};

const List = ({ mode, isReadonly, t, canSendMessage, listActions, ...rest }) => {
	const columns = [
		{
			header: t('PaymentHistory_Id'),
			accessor: 'id',
			sortable: true,
			cell: (id, row) => (<Link to={detailsLink(row.category.id, id)} >
				{id}&nbsp;
				{row.isTransferred && <LabelWithTooltip id='transferTooltip' tooltip={t('PaymentHistory_TransferTooltip')}><FontAwesomeIcon icon={faExchange} /></LabelWithTooltip>}
				{row.paymentParentId && <LabelWithTooltip id='parentTooltip' tooltip={t('PaymentHistory_ParentTooltip')}><FontAwesomeIcon icon={faLink} /></LabelWithTooltip>}
				{row.isPaymentError && !row.isInactive && <LabelWithTooltip id='еrrorTooltip' tooltip={t('PaymentHistory_ErrorTooltip')}><FontAwesomeIcon style={{ color: 'yellow' }} icon={faTriangleExclamation} /></LabelWithTooltip>}
			</Link>)
		}
	];

	columns.push(
		{
			header: t('PaymentHistory_Parent'),
			accessor: 'parent.fullname',
			cell: (parent, row) => {
				return <Link to={`/parents/${row.parent.id}`} > {row.parent.fullname}</Link>;
			},
			sortable: true
		});

	columns.push({
		header: t('PaymentHistory_Child'),
		accessor: 'child.fullname',
		cell: (child, row) => {
			return <Link to={`/parents/${row.parent.id}/children/${row.child.id}`} >
				{row.child.fullname} {row.childHasEnrolmentInTerm ? <LabelWithTooltip id='hasLessonsTooltip' tooltip={t('PaymentHistory_HasLessonsTooltip')}><FontAwesomeIcon icon={faHandshake} style={{ color: 'black' }} /></LabelWithTooltip> : ''}
			</Link>
		},
		sortable: true
	});
	columns.push({
		header: t('PaymentHistory_Center'),
		accessor: 'center',
		sortable: true
	});
	columns.push({
		header: t('PaymentHistory_NumberOfLessons'),
		accessor: 'remainingQuantity',
		sortable: true,
		cell: renderQuantityCell
	});
	columns.push({
		header: t('PaymentHistory_Total'),
		accessor: 'remainingTotal',
		sortable: true,
		cell: renderTotalCell
	});
	columns.push({
		header: t('PaymentHistory_PaidTotal'),
		accessor: 'paidTotal',
		sortable: false
	});
	columns.push({
		header: t('PaymentHistory_OutstandingTotal'),
		accessor: 'outstandingTotal',
		sortable: false
	});
	columns.push({
		header: t('PaymentHistory_DiscountAmount'),
		accessor: 'discount',
		sortable: true
	});

	columns.push({
		header: t('PaymentHistory_Status'),
		accessor: 'status',
		sortable: true,
		// a subscription whose cancellation has been requested stays Paid until the notice period ends, so it needs a label of its own
		cell: (status, row) => <span className='status-labels'> <Label bsStyle={mapStatusToLabel(status.id)}>{t(`PaymentStatusType_${status.name}`)}</Label> {row.isInactive && <Label bsStyle='inverse'>{t('PaymentStatus_Inactive')}</Label>}
			{row.cancellationRequestedLastDay && <LabelWithTooltip id='cancellationRequestedTooltip' tooltip={`${t('PaymentHistory_Subscription_LastDay')}: ${ui.formatDate(row.cancellationRequestedLastDay)}`}>
				<Label bsStyle='warning'>{t('PaymentHistory_Subscription_CancellationRequested')}</Label></LabelWithTooltip>}</span>
	});
	columns.push({
		header: t('PaymentHistory_Category'),
		accessor: 'category',
		sortable: true,
		cell: (category, row) => <span>{category.displayName}</span>
	});
	columns.push({
		header: t('PaymentHistory_Created'),
		accessor: 'created',
		sortable: true,
		cell: (created) => (ui.formatDateTime(created))
	});
	columns.push({
		header: t('PaymentHistory_PaymentMethod'),
		accessor: 'paymentMethod',
		sortable: true,
		cell: (paymentMethod) => renderPaymentMethodCell(paymentMethod)
	});
	columns.push({
		header: t('Common_Actions'),
		accessor: 'id',
		cell: (id, row) => (<div>
			<Link to={detailsLink(row.category.id, row.id)} className='btn btn-teal'> {t('Common_View')}</Link>
		</div>)
	});

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} checkboxSelection={canSendMessage} listActions={listActions} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);